import React, { memo } from "react";
import { Icon, IconProps } from "@chakra-ui/icon";

const VideoCallIcon = (props: IconProps) => (
  <Icon w="22px" h="22px" viewBox="0 0 22 22" {...props}>
    <g id="Video Call Icon" clipPath="url(#clip0_327_12314)">
      <path
        id="Union"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M19.8383 6.01432L19.8262 6.01922L16.6641 7.52859V6.35655C16.6641 5.01052 15.6055 3.88794 14.2695 3.88794H2.72785C1.39144 3.88794 0.333313 5.011 0.333313 6.35655V15.6412C0.333313 16.9872 1.3915 18.1098 2.72785 18.1098H14.2695C15.6059 18.1098 16.6641 16.9867 16.6641 15.6412V14.4693L19.792 15.9631L19.8319 15.9809L19.8387 15.9836C20.0105 16.0534 20.192 16.0925 20.378 16.0925C20.7468 16.0925 21.0892 15.9382 21.3311 15.6592C21.5595 15.3956 21.6666 15.0605 21.6666 14.7114V7.2863C21.6666 6.54274 21.1549 5.90525 20.378 5.90525C20.1923 5.90525 20.0103 5.94423 19.8383 6.01432ZM14.9197 15.6416C14.9197 16.0382 14.6122 16.3333 14.2695 16.3333H2.72785C2.3851 16.3333 2.07772 16.0385 2.07772 15.6416V6.35655C2.07772 5.95963 2.3851 5.66484 2.72785 5.66484H14.2695C14.612 5.66484 14.9197 5.95973 14.9197 6.35655V15.6416ZM20.3639 7.24801L20.3624 7.23955C20.3629 7.24212 20.3634 7.24495 20.3639 7.24801ZM19.9222 14.063L16.6644 12.5071V9.49133L19.9222 7.93545V14.063Z"
      />
    </g>
    <defs>
      <clipPath id="clip0_327_12314">
        <rect
          width="21.3333"
          height="21.3333"
          fill="white"
          transform="translate(0.333313 0.332397)"
        />
      </clipPath>
    </defs>
  </Icon>
);

export default memo(VideoCallIcon);
